// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExistingUser
 */
export interface ExistingUser {
  /**
   *
   */
  identityProviderId: string;
  /**
   *
   */
  identityProviderName: string;
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  tenantName: string;
}

/**
 * Check if a given object implements the ExistingUser interface.
 */
export function instanceOfExistingUser(value: object): value is ExistingUser {
  if (
    (!("identityProviderId" in (value as Record<string, any>)) &&
      !("identity_provider_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviderId"] === undefined &&
      (value as Record<string, any>)["identity_provider_id"] === undefined)
  )
    return false;
  if (
    (!("identityProviderName" in (value as Record<string, any>)) &&
      !("identity_provider_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviderName"] === undefined &&
      (value as Record<string, any>)["identity_provider_name"] === undefined)
  )
    return false;
  if (
    (!("tenantId" in (value as Record<string, any>)) &&
      !("tenant_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tenantId"] === undefined &&
      (value as Record<string, any>)["tenant_id"] === undefined)
  )
    return false;
  if (
    (!("tenantName" in (value as Record<string, any>)) &&
      !("tenant_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tenantName"] === undefined &&
      (value as Record<string, any>)["tenant_name"] === undefined)
  )
    return false;
  return true;
}

export function ExistingUserFromJSON(json: any): ExistingUser {
  return ExistingUserFromJSONTyped(json, false);
}

export function ExistingUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExistingUser {
  if (json == null) {
    return json;
  }
  return {
    identityProviderId: json["identity_provider_id"],
    identityProviderName: json["identity_provider_name"],
    tenantId: json["tenant_id"],
    tenantName: json["tenant_name"],
  };
}

export function ExistingUserToJSON(json: any): ExistingUser {
  return ExistingUserToJSONTyped(json, false);
}

export function ExistingUserToJSONTyped(
  value?: ExistingUser | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    identity_provider_id: value["identityProviderId"],
    identity_provider_name: value["identityProviderName"],
    tenant_id: value["tenantId"],
    tenant_name: value["tenantName"],
  };
}
